<template>
<div class="col-12 section_wrap mb-3" :class="collapseclass" ref="sectionwrap">
<div class="grid">

<div class="col-12 md:col-8 pl-3  pt-2 pb-2 display_collapse"  @click="toogleCollapse">

<div class="grid" >

<div class="col-12 pb-0">
<p class="text-primary ml-2 text-lg mb-0 cut-text " ><span class="font-semibold">{{flowname}} </span></p>
</div>



<div class="col-12 align-items-center justify-content-start flex mb-1 ">


<!-- display_tags-->
<template v-if="display_tags">

<template v-if="activeflow.id ==flowsupplier.flow_id">  
<Tag 
class="ml-2 mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.aktif" 
style="background-color:#a82400"
/>
</template>
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="flowtype" 
:style="'background-color:'+flowtypecolor"
/>

<Tag 
class="ml-2  mb-2 custom-chip" 
:value="flowstatus" 
:style="'background-color:'+flowstatuscolor"
/>

<template v-if="flowsupplier.status=='finished' || flowsupplier.status=='under_review' || flowsupplier.status=='correction_requested'">
<Tag 
v-if="opennonconformities"
class="ml-2  mb-2 custom-chip" 
:value="$store.state.languages.lang_phrases.uygunsuzluklar_var" 
style="background-color:#a82400"
v-badge.danger="nonconformitycount"
/>
</template>


</template>
<!-- display_tags-->
<!-- hide_tags-->
<template v-if="!display_tags">

<template v-if="activeflow.id ==flowsupplier.flow_id">  
<Tag 
class="ml-2 mb-2 custom-chip" 
icon="pi pi-check-circle"
style="background-color:#a82400"
/>
</template>
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="flowtype" 
:style="'background-color:'+flowtypecolor"
/>

<Tag 
class="ml-2  mb-2 custom-chip" 
:value="flowstatus" 
:style="'background-color:'+flowstatuscolor"
/>

<template v-if="flowsupplier.status=='finished' || flowsupplier.status=='under_review' || flowsupplier.status=='correction_requested'">
<Tag 
v-if="opennonconformities"
class="ml-2  mb-2 custom-chip" 
icon="pi pi-exclamation-triangle"
style="background-color:#a82400"
v-badge.danger="nonconformitycount"
/>
</template>

</template>
<!-- hide_tags-->









</div>

</div> 

<template v-if="daydifference">
  <DateRangedisplay :daydifferencedata="daydifference" v-if="daydifference"></DateRangedisplay>
</template>

<div  v-if="!daydifference" style="height: 29px;"></div>








</div>



<div class="col-12 md:col-4 pr-3  flex pt-2 pb-2 align-items-center justify-content-end">


<template  v-if="viewer=='supplier'">

<template v-if="flowsupplier.flow.type=='audit'">
  <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm rightmargin" @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
</template>

<template v-else>
  <!-- expired -->
<template v-if="!daydifference">
  <template v-if="flowsupplier.status=='created'">
     <Button :label="$store.state.languages.lang_phrases.basla"  class="p-button-white  p-button-sm rightmargin " @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
   </template> 

   <template v-if="flowsupplier.status=='started' || flowsupplier.status=='viewed'">
     <Button :label="$store.state.languages.lang_phrases.devam_et"  class="p-button-white  p-button-sm rightmargin" @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
   </template>

   <template v-if="flowsupplier.status=='finished' || flowsupplier.status=='under_review' || flowsupplier.status=='correction_requested'">
     <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm rightmargin" @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
   </template> 
</template>

<template v-else>
   <template v-if="daydifference.daysleft<=0">
    <template v-if="flowsupplier.status=='finished' || flowsupplier.status=='under_review' || flowsupplier.status=='correction_requested'">
     <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm rightmargin" @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
   </template> 
  </template>
  <!-- expired -->
<!-- not expired -->
  <template v-else>
    <template v-if="flowsupplier.status=='created'">
     <Button :label="$store.state.languages.lang_phrases.basla"  class="p-button-white  p-button-sm rightmargin " @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
   </template> 

   <template v-if="flowsupplier.status=='started' || flowsupplier.status=='viewed'">
     <Button :label="$store.state.languages.lang_phrases.devam_et"  class="p-button-white  p-button-sm rightmargin" @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
   </template>

   <template v-if="flowsupplier.status=='finished' || flowsupplier.status=='under_review' || flowsupplier.status=='correction_requested'">
     <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm rightmargin" @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
   </template> 
  </template>
  <!-- not expired -->
</template>



 
  
</template>
 
</template>

<template  v-if="viewer=='admin'">
   <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm "  :class="{ rightmargin: !menuitems.length }" @click="gotoFlowSummary(flowsupplier.uuid)" ></Button>
</template>



<template  v-if="viewer=='admin'">


<template v-if="menuitems.length">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,flowsupplier.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+flowsupplier.id" class="p-button-primary p-button-text p-button-sm mt-1"   />


<Menu :id="'overlay_menu'+flowsupplier.id" :ref="'menu'+flowsupplier.id" :model="menuitems" :popup="true">
 <template #item="{item}">  
        
  <a class="p-menuitem-link" 
  role="menuitem" 
  @click="item.command()"
  >
  <span :class="'p-menuitem-icon '+item.icon"></span>
  <span class="p-menuitem-text">{{item.label}}</span>
  <span class="p-ink"></span></a>

</template>
</Menu>  
</template>



</template>

</div>

</div>

<div class="grid" v-if="!collapsed">
  <div class="col-12" v-if="viewer=='admin'">

<div class="grid">

<div class="col-3 md:col-2"><p class="click_edit_value_title">Aşama Durumu:</p></div>
<div class="col-9 md:col-10">
<Dropdown  v-model="flowsupplier.status" :options="statuses" optionLabel="name" optionValue="code" class=" p-inputtext-sm mt-3" @change="flowsupplierStatusChanged"/>
</div>
</div>
</div>

<div class="col-12" v-if="viewer=='admin'">

<div class="grid">

<div class="col-3 md:col-2"><p class="click_edit_value_title">İstisna Tamamlama Tarihi:</p></div>
<div class="col-9 md:col-10">


<Calendar 
v-model="exception_expire_date" 
@date-select="expireDateChanged($event,flowsupplier.uuid)"   
:showButtonBar="true" 
class="p-inputtext-sm" 
:showOnFocus="true" 
:touchUI="true"  
:inline="false" 
@today-click="expireDateChanged($event,flowsupplier.uuid)" 
@clear-click="expireDateChanged($event,flowsupplier.uuid)" 
autocomplete="off" dateFormat="dd/mm/yy"  />

</div>
</div>



</div>

<div class="col-12">

</div>

</div>



</div>
</template>

<script>
import moment from "moment"
import DateRangedisplay from "./DateRangedisplay"
export default {

  name: 'CollapsableFlowCard',
  props:["flowsupplier","activeflow","viewer"],

  data () {
    return {
      display_tags:true,
    	collapsed:true,
      exception_expire_date:null,
    	loading:false,
      screenwidth:100,
      menuitems: [

      ],
      statuses:[
      {name:"Oluşturuldu",code:"created"},
      {name:"Başlandı",code:"started"},
      {name:"Görüntülendi",code:"viewed"},
      {name:"Tamamlandı",code:"finished"},
      {name:"İptal Edildi",code:"canceled"},
      {name:"Düzeltme Talep Edildi",code:"correction_requested"},
      {name:"İncelemede",code:"under_review"},
      ],
      activeflow_status:null,
    }
  },
  components:{DateRangedisplay},
  watch:{
    activeflow_id(newval)
    {
      
      this.redrawMenu()
    }
  },
  computed:{    
    opennonconformities()
    {
      if(this.flowsupplier.nonconformities && this.flowsupplier.nonconformities.length)
      {
        let open = false
        for (let i = 0; i < this.flowsupplier.nonconformities.length; i++) {
          if(this.flowsupplier.nonconformities[i].status == "open")
          {
            open = true
            break
          }
        }

        return open
      }

      return false
    },
    nonconformitycount()
    {
      if(this.flowsupplier.nonconformities && this.flowsupplier.nonconformities.length)
      {
        let opens = this.flowsupplier.nonconformities.filter((item)=>{return item.status=="open"})
        //let count = this.flowsupplier.nonconformities.length.toString()
        return opens.length.toString()
      }
      return ""
    },
    activeflow_id()
    {      
      this.redrawMenu()
      return this.activeflow.id
    },
    flowname()
    {
      if(this.flowsupplier.flow.translations)
      {
        let translation = this.flowsupplier.flow.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        if(translation)
        {
          return translation.translation
        }
        else
        {
          return this.flowsupplier.flow.name
        }
        
      }
      else
      {
        return this.flowsupplier.flow.name
      }
    },
    flowtype()
    {
      if(this.flowsupplier.flow.type=="self_evaluation")
      {
        return this.$store.state.languages.lang_phrases.self_evaluation
      }
      if(this.flowsupplier.flow.type=="education")
      {
        return  this.$store.state.languages.lang_phrases.egitim
      }
      if(this.flowsupplier.flow.type=="verification")
      {
        return  this.$store.state.languages.lang_phrases.verification
      }
      if(this.flowsupplier.flow.type=="audit")
      {
        return  this.$store.state.languages.lang_phrases.audit
      }
    },
    flowstatus()
    {
      if(this.flowsupplier.status=="created")
      {
        return this.$store.state.languages.lang_phrases.olusturuldu
      }
      if(this.flowsupplier.status=="viewed")
      {
        return this.$store.state.languages.lang_phrases.goruntulendi
      }
      if(this.flowsupplier.status=="started")
      {
        return this.$store.state.languages.lang_phrases.baslandi
      }
      if(this.flowsupplier.status=="finished")
      {
        return this.$store.state.languages.lang_phrases.tamamlandi0
      }
      if(this.flowsupplier.status=="under_review")
      {
        return this.$store.state.languages.lang_phrases.degerlendirmede
      }
      if(this.flowsupplier.status=="canceled")
      {
        return this.$store.state.languages.lang_phrases.iptal_edildi
      }
      if(this.flowsupplier.status=="correction_requested")
      {
        return this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede
      }
    },
    flowtypecolor()
    {
      if(this.flowsupplier.flow.type=="self_evaluation")
      {
        return "#ff6600"
      }
      if(this.flowsupplier.flow.type=="education")
      {
        return "#3b82f6"
      }
      if(this.flowsupplier.flow.type=="verification")
      {
        return "#7e2f8d"
      }
      if(this.flowsupplier.flow.type=="audit")
      {
        return "#352f8d"
      }
    },

    flowstatuscolor()
    {
      if(this.flowsupplier.status=="created")
      {
        return "#352f8d"
      }
      if(this.flowsupplier.status=="viewed")
      {
        return "#7e2f8d"
      }
      if(this.flowsupplier.status=="started")
      {
        return "#dd4b39"
      }
      if(this.flowsupplier.status=="finished")
      {
        return "#4dc247"
      }
      if(this.flowsupplier.status=="under_review")
      {
        return "#ff6600"
      }
      if(this.flowsupplier.status=="canceled")
      {
        return "#a82400"
      }
      if(this.flowsupplier.status=="correction_requested")
      {
        return "#3b82f6"
      }
    },
  	collapseclass()
  	{
  		if(this.collapsed)
  		{
  			return "animate-class collapsed"
  		}
  		else
  		{
  			return "animate-class expanded"
  		}
  	},
  	daydifference()
  	{
  		let start
  		let end
  		let today = moment()
  		let diff
      let today_diff
      let days_left
      if(!this.flowsupplier.flow.start_date || !this.flowsupplier.flow.end_date)
      {
        return null
      }

  		if(this.flowsupplier.flow.start_date)
  		{
  			start = moment(this.flowsupplier.flow.start_date)
  		}

  		if(this.flowsupplier.flow.end_date)
  		{
  			end = moment(this.flowsupplier.flow.end_date)
  		}
      if(this.flowsupplier.exception_expire_date)
      {
        end = moment(this.flowsupplier.exception_expire_date)
      }

  		if(start && end)
  		{
  			diff = end.diff(start, 'days') 
  		}
  		if(diff)
  		{
        today_diff = today.diff(start, 'days') 
        days_left = end.diff(today, 'days') 

  		}

  		if(today_diff)
  		{
  			days_left++
  			if(today<start)
  			{
  				return null
  			}
  			else
  			{
  				let data = Math.ceil((today_diff/diff)*100)
  				if(data>100) 
  				{
  					return {daydifference:100,daysleft:0}
  				}
  				else
  				{
  					return {daydifference:data,daysleft:days_left}
  				}
  			}
  			
  			
  		}
  		else
  		{
  			return null
  		}

  		
  	}
  },
  mounted()
  {
    console.log("CollapsableFlowCard")
    console.log(this.activeflow)
    this.activeflow_status = this.activeflow.suppliers[0].status
    this.exception_expire_date = moment(this.flowsupplier.exception_expire_date).format("DD/MM/yyyy")
    this.checkWidth()
    window.addEventListener("resize", this.checkWidth);
  },
  methods:{
    checkWidth()
    {
      console.log("checkWidth")
      let element = this.$refs.sectionwrap
      if(element)
      {
        let width = element.offsetWidth;
        console.log(width)
        if(width>450)
        {
          this.display_tags = true
        }
        else
        {
          this.display_tags = false
        }
      }
    },
    async copyEvaluationData(flowsupplier)
    {
      console.log(flowsupplier)
      //return false
      this.$store.dispatch('ui/setVerificationDataTransferModal',true) 
      this.$store.dispatch('ui/setVerificationDataTransferData',flowsupplier) 
      //let data = await this.generalApiGetWithoutLoader("clone_inputs_for_verification_with_vercode/"+flowsupplier.uuid)
      //await  this.showMessage("success","Veri Taşıma Tamamlandı")
    },
    async createPreaudit()
    {
      console.log("createPreaudit")
      let formdata = new FormData()
      formdata.append("flowsupplier_id",this.flowsupplier.id)
      this.generalSubmission(formdata,"preaudits/store_preaudit",this.aftercreatePreaudit)
    },
    aftercreatePreaudit(response)
    {
      console.log(response.data)
      this.$router.push({ name: 'Verification', params: { id:response.data.id } })
    },
    redrawMenu()
    {
      this.menuitems = []
      if(this.activeflow.id !==this.flowsupplier.flow_id)
      {
        let active_flow_obj =  {
              label: this.$store.state.languages.lang_phrases.aktif_akis_olarak_isaretle,
              icon: 'pi pi-exclamation-triangle',
              argument:this.routename,
              command: (argument,id) => {
              this.markAsActive()              
              return false
               
              }
          }
          this.menuitems.push(active_flow_obj)
          

      }
      if(this.flowsupplier.flow.type=="self_evaluation")
      {
        let preaudit_obj = {
            label:this.$store.state.languages.lang_phrases.on_gorusme_kaydi,
            icon: 'pi pi-calendar',
            argument:this.routename,
              command: (argument,id) => {                                 
                this.createPreaudit()                            
              }
          }
          this.menuitems.push(preaudit_obj)
      }

      if(this.flowsupplier.flow.type=="verification")
      {
        let verification_obj =  {
              label: this.$store.state.languages.lang_phrases.verification,
              icon: 'pi pi-calendar',
              argument:this.routename,
              command: (argument,id) => { 
                console.log(this.flowsupplier)
                if(this.flowsupplier.verification)
                {
                  this.$router.push({ name: 'Verification', params: { id:this.flowsupplier.verification.id } })
                }
              
              }
          }
          this.menuitems.push(verification_obj)

          let data_transfer_obj =  {
              label: this.$store.state.languages.lang_phrases.oz_degerlendirme_verisini_kopyala,
              icon: 'pi pi-refresh',
              argument:this.routename,
              command: (argument,id) => { 
                console.log(this.flowsupplier)
                if(this.flowsupplier.status=="finished")
                {
                  this.showMessage("error","Bu Aşama Tamamlanmış Görünüyor")
                }

                else if(this.flowsupplier.status=="started")
                {
                  this.showMessage("error","Bu Aşama Başlamış Görünüyor")
                }
                else
                {
                  this.copyEvaluationData(this.flowsupplier)
                }
              
              }
          }
          this.menuitems.push(data_transfer_obj)
      }

      if(this.flowsupplier.flow.type=="audit")
      {
        let audit_obj =  {
              label: this.$store.state.languages.lang_phrases.audit,
              icon: 'pi pi-calendar',
              argument:this.routename,
              command: (argument,id) => { 
                console.log(this.flowsupplier)
                if(this.flowsupplier.audit)
                {
                  this.$router.push({ name: 'ScheduledAudit', params: { id:this.flowsupplier.audit.id } })
                }
              
              }
          }
          this.menuitems.push(audit_obj)
      }

          
    },
    toggle(event,id) {
        console.log(event)
      //return false
        this.$refs['menu'+id].toggle(event);
    },
  	toogleCollapse()
  	{
      if(this.viewer=="admin")
      {
        this.collapsed = !this.collapsed
      }
  		
  	},
  	expand()
  	{
  		this.collapsed = false
  	},
  	expand()
  	{
  		this.collapsed = true
  	},
    gotoActiveFlow(uuid)
    {             
      this.$router.push({ name: 'Evaluation', params: { id:uuid } })
    },
    gotoFlowSummary(uuid)
    {
      
      //let userroles = this.½store.state.auth.userroles
      if(this.viewer=="supplier")
      {
        
        this.$store.dispatch('evaluation/setMode',"supplier_viewing")
        this.$router.push({ name: 'SupplierBrandFlowSummary', params: { project_id:this.flowsupplier.project_supplier.uuid,flow_id:uuid,supplier_uuid:this.flowsupplier.supplier.uuid } })
      }
      if(this.viewer=="admin")
      {
        this.$store.dispatch('evaluation/setMode',"admin_viewing")
        this.$router.push({ name: 'SupplierProjectFlowSummary', params: { project_id:this.$route.params.project_id,flow_id:uuid } })
      }
    },
    markAsActive()
    {
      console.log(this.flowsupplier.flow.id)
      //return false
      this.loading = true
      let formdata = new FormData()
      formdata.append("activeflow_id",this.flowsupplier.flow.id)
      this.generalSubmission(formdata,"audit/update_project_active_flow/"+this.$route.params.project_id,this.aftermarkAsActive)
    },
    aftermarkAsActive(response)
    {
      console.log(response.data)
      this.loading = false
      this.$emit("activeFlowUpdated",response.data)
    },
    flowsupplierStatusChanged()
    {
      
      let formdata = new FormData()
      formdata.append("flowsupplier_id",this.flowsupplier.id)
      console.log(this.status)
      //return false
      formdata.append("new_status",this.flowsupplier.status)
      this.generalSubmission(formdata,"supplier/update_flowsupplier_status/"+this.flowsupplier.id,this.afterdataChanged)
    },
    expireDateChanged(data,uuid)
    {
      console.log("dataChanged")
      console.log(data)
      console.log(uuid)      
      let formdata = new FormData()
      formdata.append("exception_expire_date",moment(data).toISOString())
      this.generalSubmission(formdata,"update_flow_supplier_expire_date/"+uuid,this.afterexpireDateChanged)
    },
    afterexpireDateChanged(response)
    {
      console.log(response.data)
      this.exception_expire_date = moment(response.data.exception_expire_date).format("DD/MM/yyyy")
    },
    afterdataChanged(response)
    {

      console.log(response)
      //this.activeflow.suppliers[0] = response.data
    }
  }
}
</script>

<style lang="css" scoped>
.collapsed{
    min-height: 120px;
  }
  .expanded{
    min-height: 250px;
  }
  .display_collapse{
  	cursor: pointer;
  }
  .rightmargin{
    margin-right: 38px;
  }
</style>